import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1207b8e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window",
  style: {
    "height": "600px"
  }
};
var _hoisted_2 = {
  class: "flex flex_between"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  class: "footer flex flex_justify_center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_Process = _resolveComponent("Process");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "难事上报"
  }), _createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.back && _ctx.back.apply(_ctx, arguments);
    })
  }, [_hoisted_3, _createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_ArrowRight, {
        color: "#c62423"
      })];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_Process, {
    ref: "RefProcess",
    title: "跟进记录"
  }, null, 512)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.submit();
    })
  }, " 提交 ")])]);
}